import { h } from 'preact';

import './Sidebar.scss';

export default () => (
    <aside class="sidebar">
        {/* <div class="sidebar__contact-item">
            <div class="sidebar__contact-image"></div>
            <div class="sidebar__contact_details">
                <p>Dr. Béres-Deák Ügyvédi Iroda</p>
                <address>
                    3200 Gyöngyös,<br/>
                    Május 1. lépcső 6.<br />
                    +36-30-317-418
                </address>
            </div>
        </div> */}
        <div class="sidebar__box">
            <div class="sidebar__contact-item">
                <div class="sidebar__contact-image">
                    <img src="/images/bda.jpg" />
                </div>
                <div class="sidebar__contact_details">
                    <p>Dr. Béres-Deák Attila</p>
                    <p>Ügyvéd, vámjogász</p>
                    <p>+36-30-214-7777</p>
                    <p><a href="mailto:attila.beres-deak@jogitanacs.info">attila.beres-deak@jogitanacs.info</a></p>

                </div>
            </div>
            <hr/>
            <div class="sidebar__contact-item">
                <div class="sidebar__contact-image">
                    <img src="/images/isz.jpg" />
                </div>
                <div class="sidebar__contact_details">
                    <p>Dr. Béres-Deákné Iványi Szilvia</p>
                    <p>Gazdasági mediátor</p>
                    <p>+36-30-502-2382</p>
                    <p><a href="mailto:szilvia.ivanyi@jogitanacs.info">szilvia.ivanyi@jogitanacs.info</a></p>
                </div>
            </div>
        </div>
        <hr/>
        <form class="sidebar__contact-form" name="sidebar-contact" action="/koszonjuk" method="post" netlify netlify-honeypot="hagyduresen">
            <input type="hidden" name="form-name" value="sidebar-contact" />
            <div class="form-row hagyduresen">
                <label>Ezt hagyja üresen <input name="hagyduresen"/></label>
            </div>
            <div class="form-row">
                <label>Név <input type="text" name="name"/></label>
            </div>
            <div class="form-row">
                <label>E-mail <input type="email" name="email"/></label>
            </div>
            <div class="form-row">
                <label>Üzenet <textarea name="message" rows="6"></textarea></label>
            </div>
            <div class="form-row">
                <button type="submit" class="btn--primary">Üzenetküldés</button>
            </div>
        </form>
        <hr/>
        <iframe style="margin-bottom: 12px;" src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2Fberes-deak&tabs&width=340&height=154&small_header=true&adapt_container_width=true&hide_cover=true&show_facepile=true&appId" height="154" style="border:none;overflow:hidden;width:100%;margin-bottom:12px;" scrolling="no" frameborder="0" allowTransparency="true"></iframe>
    </aside>
);


// WEBPACK FOOTER //
// ./src/components/Sidebar.js